import { SxProps } from '@mui/material';
import { bluePlanetTheme } from 'ui/theme';
import { contentSpacing } from 'ui/theme/themeConstants';

export const postInputFieldStyles: SxProps = {
  '.MuiInput-root': {
    borderColor: bluePlanetTheme.bluePlanetPalette.grey.main,
    borderRadius: `calc(${contentSpacing} * 4)`,
    paddingLeft: contentSpacing,
    paddingRight: contentSpacing,
    '&:hover': {
      borderColor: bluePlanetTheme.bluePlanetPalette.grey.main,
    },
    '&:focus': {
      borderColor: bluePlanetTheme.bluePlanetPalette.grey.main,
    },
    '&:active': {
      borderColor: bluePlanetTheme.bluePlanetPalette.grey.main,
    },
    '&.Mui-focused': {
      borderColor: bluePlanetTheme.bluePlanetPalette.grey.main,
    },
    '& input::placeholder': {
      color: bluePlanetTheme.bluePlanetPalette.grey.dark,
      opacity: 1,
    },
  },
};
